<template>
  <div class="container-entities">
    <p>
      Administra todas las campañas de las empresas a las cuáles le brindas servicios.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a>
      para conocer más.
    </p>
    <a-row class="controls" type="flex" justify="space-between">
      <a-col>
        <a-form layout="inline" :model="formState">
          <a-form-item>
            <a-input
              v-model:value="formState.search"
              placeholder="Buscar por campaña"
              class="form__input"
            >
              <template #prefix>
                <SearchOutlined />
              </template>
            </a-input>
          </a-form-item>
          <a-form-item>
            <!-- <a-select
:getPopupContainer="triggerNode => triggerNode.parentNode"              v-model:value="selectedEntity"
              placeholder="Seleccione empresa"
              class="form__select"
              @change="fetchChampaigns"
            >
              <a-select-option :key="0"> Todas las empresas </a-select-option>
              <a-select-option v-for="entity in entities" :key="entity.id">
                {{ entity.name }}
              </a-select-option>
            </a-select> -->
            <EntityPicker
              v-if="user?.customer?.type_business == 1"
              defaultBehavior
              v-model:value="formState.entity"
              class="form__select"
            />
          </a-form-item>
        </a-form>
      </a-col>
      <a-col>
        <a-button
          type="primary"
          id="add-new-portfolio"
          class="campaigns--add"
          @click="createPortfolioModal = true"
        >
          Agregar nueva campaña
        </a-button>
      </a-col>
    </a-row>
    <TableWallets :user="user ? user : {}" :loading="loading" @update="fetchChampaigns" />
  </div>

  <PortfolioModal
    v-if="createPortfolioModal"
    v-model:open="createPortfolioModal"
    @update="fetchChampaigns"
  />
</template>

<script>
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { SearchOutlined } from "@ant-design/icons-vue";
import _ from "lodash";

import PortfolioModal from "@/app/entities/components/modals/campaigns/PortfolioModal.vue";
import TableWallets from "../tables/TableWallets.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";

export default defineComponent({
  components: {
    PortfolioModal,
    TableWallets,
    SearchOutlined,
    EntityPicker,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const createPortfolioModal = ref(false);
    const loading = ref(false);

    const formState = reactive({
      search: route.query?.search || "",
      entity: Number(route.query?.entity) || "",
    });

    const fetchChampaigns = async (page = 1) => {
      loading.value = true;

      await store.dispatch("fetchAllPortfoliosByEntity", {
        filters: {
          search: formState.search,
          entity: formState.entity,
        },
        page,
      });

      loading.value = false;
    };

    onMounted(() => fetchChampaigns());

    watch(formState, _.debounce(fetchChampaigns, 500));

    return { loading, formState, fetchChampaigns, createPortfolioModal };
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/campañas-1/`;

    return {
      search: this.$route.query?.defaultSearch || "",
      selectedStatus: 0,
      DOCS_URL,
    };
  },
  computed: {
    user() {
      return this.$store.getters["getDataUser"];
    },
    // selectedEntity: {
    //   get() {
    //     return this.$store.getters["getSelectedEntity"];
    //   },
    //   set(entityId) {
    //     this.$store.dispatch("setSelectedEntity", entityId);
    //   },
    // },
    // entities() {
    //   return this.$store.getters["getEntityList"];
    // },
  },
  // created() {
  //   this.$store.dispatch("fetchAllPortfoliosByEntity");
  // },
  // methods: {
  //   fetchChampaigns: (pagination) =>
  //     _.debounce(async function () {
  //       this.loading = true;

  //       await this.$store.dispatch("fetchAllPortfoliosByEntity", {
  //         filters: {
  //           search: this.search,
  //           status: this.selectedStatus,
  //         },
  //         pagination,
  //       });

  //       this.loading = false;
  //     }, 500),
  // },
});
</script>

<style lang="sass" scoped>
.container-entities
  padding: 8px 20px
  background-color: white
  border-radius: 10px
  border-top-left-radius: 0

.controls
  margin-bottom: 12px

.entradaBoton
  display: flex
  justify-content: space-between
  margin-top: 20px
  margin-bottom: 24px
  widows: 100%

.form__input
  width: 380px

.form__select
  width: 180px !important
</style>
